import{z as e}from"zod";const t=e.object({}).strict();export{t as updateAppAssignmentDto};
//# sourceMappingURL=update-app-assignment.dto.mjs.map